import { Button, Dropdown, Row, Space } from "antd";
import TableAntd from "components/elements/Table";
import { ReactComponent as CreateIcon } from "../../../../assets/icon/createIcon.svg";
import { useTranslation } from "react-i18next";
import { DeleteOutlined, DownOutlined, EditOutlined, EnterOutlined, EyeOutlined, MoreOutlined, UpOutlined } from "@ant-design/icons";
import SettingProjectAddTaskModal from "./SettingProjectAddTaskModal";
import { ReactComponent as UpIcon } from "../../../../assets/icon/upArrow.svg";
import { ReactComponent as DownIcon } from "../../../../assets/icon/downArrown.svg";
import { useCallback, useEffect, useMemo, useState } from "react";

const SettingProjectAllTask = ({
    isModalOpen,
    showModal = () => { },
    onCancel = () => { },
    onSubmit = () => { },
    taskOption = [],
    taskPagination = [],
    onEditTask = () => { },
    onViewTask = () => { },
    taskOnEdit = {},
    paginationTask = {},
    onPageTaskChange = () => { },
    isView = false,
    isLoading = false,
    roleOption = [],
    onRoleChange = () => { },
    selectedRoleId,
    onDeleteRole = () => { },
    onDeleteTask = () => { }
}) => {
    const { t, i18n } = useTranslation();

    const sortTasks = (data, lang = "th") => {
        return data
            .slice()
            .sort((a, b) => {
                const nameA = lang === "en" ? a?.taskNameEn || "" : a?.taskName || "";
                const nameB = lang === "en" ? b?.taskNameEn || "" : b?.taskName || "";
                return nameA?.localeCompare(nameB, lang);
            })
            .map(item => ({
                ...item,
                children: item?.children ? sortTasks(item?.children, lang) : undefined
            }));
    };

    const CustomExpandIcon = (props) => {
        const isRole = !!props?.record?.role?.roleName && !props?.record?.taskName;

        if (!isRole && props.expanded == false) {
            props.expanded = true
            props.onExpand(props.record, true)
        }

        if (!isRole) {
            return null;
        }

        return (
            <Space
                onClick={(e) => props.onExpand(props.record, e)}
                style={{
                    justifyContent: "center",
                    width: 24,
                    marginRight: 8,
                    cursor: "pointer",
                }}
            >
                {props.expanded ? <UpIcon /> : <DownIcon />}
            </Space>
        );
    };

    const columns = useMemo(() => [
        {
            title: <div className="text-table" style={{ textAlign: "center" }}>{t('setting_timesheet.label.roles')}</div>,
            dataIndex: "roleName",
            key: "roleName",
            width: 280,
            render: (_, record) => {
                return !record?.taskName ? (
                    <span>{record?.role?.roleName}</span>
                ) : null;
            }
        },
        {
            title: <div className="text-table">{t('setting_timesheet.label.all_work')}</div>,
            dataIndex: "taskName",
            key: "taskName",
            render: (_, record) => {
                const isSubTask = record?.underTaskId;
                const isTask = record?.taskName;

                return (
                    <div style={{ paddingLeft: isSubTask ? 40 : 0 }}>
                        {isTask || isSubTask ?
                            <EnterOutlined style={{
                                transform: "scaleX(-1)",
                                color: "#757575",
                                marginRight: "8px"
                            }} />
                            : null}
                        {i18n.language == "en" ? record?.taskNameEn : record?.taskName}
                    </div>
                );
            }
        },
        {
            title: "",
            key: "action",
            align: "center",
            width: 90,
            render: (_, record) => {
                const isRole = !!record?.role?.roleName && !record?.taskName;

                const items = isRole
                    ? [
                        {
                            key: "delete",
                            label: t("common.delete"),
                            icon: <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />,
                            onClick: () => onDeleteRole(record)
                        },
                    ]
                    : [
                        {
                            key: "edit",
                            onClick: () => onEditTask(record),
                            label: isView ? t("action.view") : t("action.edit"),
                            icon: isView ? (
                                <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                            ) : (
                                <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                            ),
                        },
                        {
                            key: "delete",
                            label: t("common.delete"),
                            icon: <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />,
                            onClick: () => onDeleteTask(record)
                        },
                    ];

                return (

                    <Space size="middle">
                        <Dropdown
                            menu={{ items }}
                        >
                            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                        </Dropdown>
                    </Space>
                )
            },
        }
    ], [i18n.language, isView, onDeleteRole, onEditTask, t])

    const tableAntdCall = useCallback(
        () => {
            return <TableAntd
                columns={columns}
                dataSource={sortTasks(taskPagination, i18n.language).map(o => ({ ...o, expanded: true }))}
                rowKey={(record) => record.id ?? record?.role?.roleId}
                expandable={{
                    expandIcon: CustomExpandIcon,
                    indentSize: 32,
                }}
                // pagination={paginationTask}
                // onChange={onPageTaskChange}
                loading={isLoading}
            />
        },
        [columns, taskPagination, i18n.language, isLoading],
    )
    return (
        <>
            <SettingProjectAddTaskModal
                isModalOpen={isModalOpen}
                onCancel={onCancel}
                onSubmit={onSubmit}
                taskOption={taskOption}
                roleOption={roleOption}
                taskOnEdit={taskOnEdit}
                isView={isView}
                onRoleChange={onRoleChange}
                selectedRoleId={selectedRoleId}
            />
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Row justify={"end"}>
                    {!isView && (
                        <Button
                            type="primary"
                            style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", backgroundColor: "var(--button-color)" }}
                            icon={<CreateIcon style={{ fontSize: 16 }} />}
                            onClick={() => {
                                showModal()
                            }}
                        >
                            {t("setting_timesheet.label.add_task")}
                        </Button>
                    )}
                </Row>
                {tableAntdCall()}
            </Space>
        </>
    )
}

export default SettingProjectAllTask;